export class InviteNotFound extends Error {
  public constructor() {
    super()

    this.message = 'invitePage.inviteErrors.notFound'
  }
}
